import type { Prototype } from "../prototype-types";

export const kevinGengPrototypes: Prototype[] = [
  {
    id: "kg-preactivation-homepage-v1",
    name: "Preactivation Homepage V1 — Focused",
    path: "/kg/preactivation-homepage-v1",
    description:
      "V1 focused pre-activation card: catalog completeness leading to go-live, no clickable stepper. Combines the two-product minimum with the catalog-completeness recommendation.",
    owner: "Kevin Geng",
    project: "Brand Portal Homepage",
    createdAt: "2026-08-07",
    lastUpdated: "2026-08-10",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9596540d48e22688153f1c0a442e2c5cd26e04ffcbb2153c2b872a7ebf9b7b19.png",
  },
  {
    id: "kg-preactivation-homepage-v2",
    name: "Preactivation Homepage V2 — Lifecycle",
    path: "/kg/preactivation-homepage-v2",
    description:
      "V2 progressive lifecycle accordion: Brand Home setup card as Step 1, then go live, get featured, and grow — with catalog vs two-product framing variants.",
    owner: "Kevin Geng",
    project: "Brand Portal Homepage",
    createdAt: "2026-07-24",
    lastUpdated: "2026-08-10",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a3ece4acba531cc164ae48bc664b18043256892db266ab0dc4ab5efeeb53388f.png",
  },
  {
    id: "kg-brand-portal-tours",
    name: "Brand Portal Tours",
    path: "/kg/brand-portal-tours",
    description:
      "POC of the Brand Portal tour framework: declarative ITourConfig, Slate GuidedTour runner, mock milestones, and PETE event log.",
    owner: "Kevin Geng",
    project: "Brand Portal Tours",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-17",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/03e98f5427e75267cffd3586af8b7856b0d95a1676af5fa16e82cab7ba6fb9a5.png",
  },
  {
    id: "kg-new-brand-homepage-states",
    name: "New Brand Homepage States",
    path: "/kg/new-brand-homepage-states",
    description:
      "Every brand homepage state from finishing onboarding to the evergreen dashboard: self-serve catalog setup, review and IDV holds, rejection, go live, the Featured New Arrivals checklist, the featured period, Faire Direct incentives, and evergreen, with trigger rules from production.",
    owner: "Kevin Geng",
    project: "Brand Portal Homepage",
    createdAt: "2026-10-07",
    lastUpdated: "2026-10-07",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/kg-new-brand-homepage-states.png",
  },
];
